import { useEffect } from 'react';
import { useEditor } from '@tiptap/react';
import { Color } from '@tiptap/extension-color';
import { default as TextStyle } from '@tiptap/extension-text-style';
import { default as Underline } from '@tiptap/extension-underline';
import { default as Highlight } from '@tiptap/extension-highlight';
import { default as StarterKit } from '@tiptap/starter-kit';
import { default as Placeholder } from '@tiptap/extension-placeholder';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import Image from '@tiptap/extension-image';
import { CustomTableCell, CustomTable, CustomParagraph } from './customExtensions';
import { cleanHtml } from '@components/utils';

export function useRichText({ onChange, placeholder, value, onFocus, onBlur }) {
  let extensions = [
    Underline,
    TextStyle,
    Color.configure({ types: [TextStyle.name] }),
    Highlight.configure({ multicolor: true }),
    StarterKit,
    Placeholder.configure({ placeholder: placeholder && `${placeholder}` }),
    TableRow,
    TableHeader,
    CustomTableCell,
    CustomParagraph,
    Image.configure({ inline: true }),
    CustomTable
  ];

  const editor = useEditor({
    extensions,
    onUpdate: ({ editor }) => {
      if (onChange) {
        const htmlEditorData = editor.getHTML();
        onChange(htmlEditorData);
      }
    },
    // editorProps: {
    //   handlePaste: (view, event, slice) => {
    //     event.preventDefault();
    //     const text = event.clipboardData.getData('text/plain');
    //     const lines = text.split(/\r\n|\r|\n/);
    //     const content = lines.join('\n');
    //     view.dispatch(view.state.tr.insertText(content));
    //     return true;
    //   }
    // },
    onFocus: ({ editor }) => onFocus(cleanHtml(editor.getHTML())),
    onBlur: ({ editor }) => onBlur(cleanHtml(editor.getHTML())),
    content: value
  });

  useEffect(() => {
    if (editor && value) {
      let { from, to } = editor.state.selection;

      editor.commands.setContent(value, false, {
        preserveWhitespace: 'full'
      });

      editor.commands.setTextSelection({ from, to });
    }
  }, [value]);

  return { editor };
}
